/**
 * Forwards Klaviyo form signups to Shopify's customer events, so custom pixels
 * (Settings > Customer events) can track them without any vendor code in the theme.
 *
 * Klaviyo only fires "submit" once a signup passes its own validation, so empty
 * or invalid emails never reach the pixels. Pixels subscribe to the event below
 * and filter on formId, e.g. the Rumble lead pixel listens for form W46Nw5.
 */
(function () {
  "use strict";

  var EVENT_NAME = "klaviyo_form_submitted";

  window.addEventListener("klaviyoForms", function (e) {
    var detail = e.detail || {};
    if (detail.type !== "submit") return;
    if (!window.Shopify || !Shopify.analytics || typeof Shopify.analytics.publish !== "function") return;

    Shopify.analytics.publish(EVENT_NAME, {
      formId: detail.formId,
      formVersionId: detail.formVersionId
    });
  });
})();
